import React from 'react';
import { observer } from 'mobx-react';
import get from 'lodash/get';
import Integrations from 'containers/Integrations';
import IntegrationDetails from 'containers/IntegrationDetails';
import Agencies from 'containers/Agencies';
import AgencyDetails from 'containers/AgencyDetails';

import integrationsPageStore from 'stores/Page/Integrations/IntegrationsPageStore';
import integrationDetailsPageStore from 'stores/Page/IntegrationDetails/DetailsPageStore';
import agenciesPageStore from 'stores/Page/Agencies/AgenciesPageStore';
import agencyDetailsPageStore from 'stores/Page/AgencyDetails/DetailsPageStore';
import * as constants from 'Constants';
import * as api from 'Api';
import * as utils from 'Utils';


@observer
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.config = window.PARTNERS_CONFIG || {};
    this.qs = utils.parseQueryString(window.location.search) || {};

    if (!this.config || !this.config.page_type) return;
    this.loadData();
  }

  loadData = () => {
    if (this.config.page_type === 'INTEGRATIONS') this.loadIntegrationsPage();
    if (this.config.page_type === 'INTEGRATION_DETAILS') this.loadIntegrationDetailsPage();
    if (this.config.page_type === 'AGENCIES') this.loadAgenciesPage();
    if (this.config.page_type === 'AGENCY_DETAILS') this.loadAgencyDetailsPage();
  };

  loadIntegrationsPage = () => {
    const successCallback = (response) => {
      integrationsPageStore.deserialize(response);
      integrationsPageStore.setLoaded(true);
    };

    const errorCallback = (errors) => {
      console.error(errors);
    };

    api.getViewIntegrations(successCallback, errorCallback, this.qs);
  };

  loadIntegrationDetailsPage = () => {
    const successCallback = (response) => {
      integrationDetailsPageStore.deserialize(response);
      integrationDetailsPageStore.setLoaded(true);
    };

    const errorCallback = (errors) => {
      console.error(errors);
    };

    const integrationId = this.config.integration_id;
    api.getViewIntegrationDetails(successCallback, errorCallback, integrationId);
  };

  loadAgenciesPage = () => {
    const successCallback = (response) => {
      agenciesPageStore.deserialize(response);
      agenciesPageStore.setLoaded(true);
    };

    const errorCallback = (errors) => {
      console.error(errors);
    };

    api.getViewAgencies(successCallback, errorCallback, this.qs);
  };

  loadAgencyDetailsPage = () => {
    const successCallback = (response) => {
      agencyDetailsPageStore.deserialize(response);
      agencyDetailsPageStore.setLoaded(true);
    };

    const errorCallback = (errors) => {
      console.error(errors);
    };

    const agencyId = this.config.agency_id;
    api.getViewAgencyDetails(successCallback, errorCallback, agencyId);
  };

  render() {
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: require('static/icons/bp-icon.svg').default}} />
        <div dangerouslySetInnerHTML={{__html: require('static/icons/fa-icon.svg').default}} />
        {integrationsPageStore.loaded ? (
          <Integrations
            qs={this.qs}
          />
        ): null}

        {integrationDetailsPageStore.loaded ? (
          <IntegrationDetails
            qs={this.qs}
          />
        ): null}

        {agenciesPageStore.loaded ? (
          <Agencies
            qs={this.qs}
          />
        ): null}

        {agencyDetailsPageStore.loaded ? (
          <AgencyDetails
            qs={this.qs}
          />
        ): null}
      </div>
    )
  }
}



export default App;
